import { Anchor, Loader, Paper, Stack, Text, Title } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { api, podatki } from '../api/odjemalec';
import { NapakaApi, sporocilo } from '../api/napaka';
import { TemnoOzadje } from '../postavitev/TemnoOzadje';
import { seja } from '../seja/seja';
import { NapakaVstopa, NazajNaPrijavo, ObrazecGesla } from './vstop';
import { zetonIzPovezave } from './zeton';

/**
 * Potrditev registracije iz povezave v e-pošti ({@code /registracija/potrditev#žeton}): stranka nastavi geslo, strežnik
 * ustvari instanco s preizkusom, nato se aplikacija prijavi in odpre začetni zaslon.
 */
export function PotrditevRegistracije() {
  const navigate = useNavigate();
  const [zeton] = useState(zetonIzPovezave);
  const povzetek = useQuery({
    queryKey: ['registracija', 'potrditev', zeton],
    retry: false,
    queryFn: ({ signal }) => podatki(api.GET('/api/registracija/potrditev', { signal, params: { query: { zeton } } })),
  });

  const nastavi = async (geslo: string) => {
    const o = await podatki(api.POST('/api/registracija/potrditev', { body: { zeton, geslo } }));
    await seja.prijava(o.uporabniskoIme!, geslo);
    window.history.replaceState(null, '', '/');
    void navigate('/', { replace: true });
  };

  return (
    <TemnoOzadje>
      <Paper radius="lg" p={36} shadow="xl">
        {povzetek.isPending ? (
          <Stack align="center" py="lg">
            <Loader aria-label="Nalagam" />
          </Stack>
        ) : povzetek.data ? (
          <Stack gap="md">
            <ObrazecGesla
              naslov="Nastavite geslo"
              opis={
                <>
                  Zadnji korak registracije podjetja <b>{povzetek.data.naziv}</b>. Prijavljali se boste z e-pošto{' '}
                  <b>{povzetek.data.email}</b>.
                </>
              }
              gumb="Nastavi geslo in začni"
              nastavi={nastavi}
            />
          </Stack>
        ) : (
          <Neveljavna napaka={povzetek.error} />
        )}
      </Paper>
    </TemnoOzadje>
  );
}

function Neveljavna({ napaka }: { napaka: unknown }) {
  const potrjena = napaka instanceof NapakaApi && napaka.koda === 'REGISTRACIJA_POTRJENA';
  return (
    <Stack gap="md">
      <Title order={2} size="h3">
        {potrjena ? 'Registracija je že potrjena' : 'Povezava ne velja'}
      </Title>
      {potrjena ? (
        <Text size="sm">Prijavite se z e-poštnim naslovom in geslom, ki ste ga nastavili.</Text>
      ) : (
        <NapakaVstopa>{sporocilo(napaka)}</NapakaVstopa>
      )}
      {!potrjena && (
        <Text size="sm" ta="center">
          <Anchor component={Link} to="/registracija">
            Registrirajte se znova
          </Anchor>
        </Text>
      )}
      <NazajNaPrijavo besedilo={potrjena ? 'Na prijavo' : 'Nazaj na prijavo'} />
    </Stack>
  );
}
